import { MobileWrapperV2 } from './MobileWrapperV2/index.js';
import { Modal } from './Modal.js';
import { ModalContentWrapper } from './ModalContentWrapper/index.js';

const ModalComponent = {
  Modal,
  MobileWrapperV2,
  ModalContentWrapper
};

export { ModalComponent };
//# sourceMappingURL=index.js.map
